
import {
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    Typography,
    Input,
    Checkbox,
    Button,
    Textarea,
  } from "@material-tailwind/react";
import { FaRegCircleCheck, FaUser } from "react-icons/fa6";
import { HiUser } from "react-icons/hi";
import { HiEnvelope, HiOutlineBuildingLibrary, HiOutlineEnvelope, HiOutlineUser } from "react-icons/hi2";
import { AiOutlinePhone } from "react-icons/ai";
import { useContext, useState } from "react";
import { OrderContext } from "../../context/order.context";
import { IoWarning } from "react-icons/io5";
   
  export function InterpretationCard() {


    const { addInquiry } = useContext(OrderContext);

    const defaultValues = {
      org: '',
      fname: '',
      sname: '',
      name: '',
      email: '',
      phone: '',
      message: '',
      status: 'no',
      fileinc: 'no',
      type: 'interpreting',
      del: 'no',
      created_at: new Date(),
      updated_at: null,
    }
    
    const [ inquire, setInquire ] = useState(false);
    const [ inquiryText, setInquirText ] = useState('');
    const [ formFields, setFormFields ] = useState(defaultValues);

    const inquireClick = () => {
      setInquire(!inquire)
      setInquirText('')
    }

    const changeFieldText = (event) => {
      const { name, value } = event.target;
      setFormFields({...formFields, [name]: value})
      // console.log(value)
    }

    const submitInquiry = async (event) => {
      event.preventDefault()

      formFields['name'] = `${formFields.fname} ${formFields.sname}`.trim();
      console.log(formFields)

      await addInquiry(formFields).then(
        setInquirText('y'),
        setInquire(!inquire),
        setFormFields(defaultValues)
      );
    };


    return (
      <Card className="w-full sm:w-96 mb-10 sm:mb-0">
        <CardHeader
          variant="gradient"
          color="gray"
          className="mb-4 grid place-items-center rounded-lg h-20"
        >
          <Typography variant="h5" color="white" className="">
            Request Consultation
          </Typography>
        </CardHeader>
        <form onSubmit={submitInquiry}>
        <CardBody className="flex flex-col gap-4">

          { inquiryText === 'y' ?
              <Button type="button" variant='outlined' color='green' size='lg' className="flex text-center text-xs tracking-wider font-light my-2 rounded-full"><FaRegCircleCheck size={16} />&nbsp;Inquiry Submitted</Button>
          : inquiryText === 'x' ?
              <Button type="button" variant='outlined' color='red' size='lg' className="flex text-center text-xs tracking-wider font-light my-2 rounded-full"><IoWarning size={16} />&nbsp;Oops..! An Error Occured</Button>
          :null }

          <div>
            <Input type="text" label="Firstname" size="lg" icon={<HiOutlineUser />} name="fname" value={formFields.fname} onChange={changeFieldText} required/>
          </div>
          <div>
            <Input type="text" label="Last Name" size="lg" icon={<HiOutlineUser />} name="sname" value={formFields.sname} onChange={changeFieldText} required/>
          </div>
          <div>
            <Input type="email" label="Email" size="lg" icon={<HiOutlineEnvelope />} name="email" value={formFields.email} onChange={changeFieldText} required/>
          </div>
          <div>
            <Input type="number" min={0} label="Phone" size="lg" icon={<AiOutlinePhone />} name="phone" value={formFields.phone} onChange={changeFieldText} required/>
          </div>
          <div>
            <Input type="text" label="Organization" size="lg" icon={<HiOutlineBuildingLibrary />} name="org" value={formFields.org} onChange={changeFieldText} />
          </div>
          <Typography variant="h6" className="leading-5 px-2">Additional Information & Requested Language(s)
            <span className="italic text-red-500 font-light text-sm"> (Required)</span>
          </Typography>
          <div className="">
            <Textarea maxLength={500} label="Enter Message" name="message" value={formFields.message} onChange={changeFieldText} required/>
            <p className="text-xs font-light">Note: 500 maximum characters</p>
          </div>
        </CardBody>
        <CardFooter className="pt-0">
          <Button type="submit" variant="gradient" fullWidth>
            Send Request
          </Button>
          <Typography variant="small" className="mt-6 flex justify-center">
            Already a member?
            <Typography
              as="a"
              href="#signup"
              variant="small"
              color="blue-gray"
              className="ml-1 font-bold"
            >
              Follow Up!
            </Typography>
          </Typography>
        </CardFooter>
        </form>
      </Card>
    );
  }